import { render } from "./EditConfigModal.vue?vue&type=template&id=36e4d5c6&scoped=true"
import script from "./EditConfigModal.vue?vue&type=script&lang=js"
export * from "./EditConfigModal.vue?vue&type=script&lang=js"

import "./EditConfigModal.vue?vue&type=style&index=0&id=36e4d5c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e4d5c6"]])

export default __exports__